/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

export enum BannerType {
  DEFAULT = 'default',
  SUCCESS = 'success',
  ALERT = 'alert',
  ERROR = 'error',
}
